<template>
  <div class="z-card bill-card">
    <bill-card-loader v-if="loadingCurrentBill" />

    <template v-else-if="currentBill">
      <fully-paid-contract
        :contract="currentContract"
        v-if="isContractFullyPaid"
      />

      <paid-bill
        :bill="currentBill"
        :payment-method="currentBilling.recurrent_payment_method"
        :credit-card="currentBilling.student_card"
        v-else-if="isPaid"
      />

      <overdue-bill
        :overdue-bills="overdueBills"
        :with-scholarship="isFromQb"
        v-else-if="isOverdue"
      />

      <open-bill
        :bill="currentBill"
        :payment-method="currentBilling.recurrent_payment_method"
        :credit-card="currentBilling.student_card"
        v-else
      />
    </template>

    <unavailable-bill v-else />
  </div>
</template>

<style lang="scss" scoped>

.bill-card {
  @media (max-width: $screen-sm-max) {
    margin-bottom: var(--space-medium);
  }
}
</style>

<script>
import { mapState } from 'vuex';
import BillCardLoader from 'content-loaders/bill-card-loader';
import FullyPaidContract from './fully-paid-contract';
import OpenBill from './open-bill';
import OverdueBill from './overdue-bill';
import PaidBill from './paid-bill';
import UnavailableBill from './unavailable-bill';

export default {
  components: {
    BillCardLoader,
    FullyPaidContract,
    OpenBill,
    OverdueBill,
    PaidBill,
    UnavailableBill,
  },
  computed: {
    ...mapState([
      'currentBilling',
      'currentBill',
      'loadingCurrentBill',
      'currentContract',
      'overdueBills',
    ]),
    isContractFullyPaid() {
      return this.currentContract.status === 'finished';
    },
    isPaid() {
      return this.currentBill.status === 'paid';
    },
    isOverdue() {
      return this.overdueBills.length > 0;
    },
    isFromQb() {
      return this.currentBilling.origin === 'from_qb';
    },
  },
};
</script>
